import React, { useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useTranslation } from "react-i18next";

import Colors from "../../../Resources/Color";
import { useDevice } from "../../_layout";

export function NutritionOfflineBlockedView({ onGoToDashboard }) {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <Ionicons
          name="cloud-offline-outline"
          size={20}
          color={Colors.grayColor}
          style={styles.icon}
        />
        <Text style={styles.title}>{t("nutritionOfflineTitle-string")}</Text>
        <Text style={styles.description}>
          {t("nutritionOfflineDescription-string")}
        </Text>
        <TouchableOpacity
          onPress={onGoToDashboard}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={[styles.button, isHovered ? styles.buttonHovered : null]}
        >
          <Text style={styles.buttonText}>
            {t("nutritionOfflineGoToDashboard-string")}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  card: {
    width: "100%",
    maxWidth: 360,
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 18,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    backgroundColor: "rgba(255, 255, 255, 0.92)",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  icon: {
    marginBottom: 10,
  },
  title: {
    fontSize: 14,
    fontWeight: "600",
    color: Colors.darkgrayColor,
    textAlign: "center",
  },
  description: {
    marginTop: 8,
    fontSize: 12,
    lineHeight: 17,
    color: Colors.grayColor,
    textAlign: "center",
  },
  button: {
    marginTop: 16,
    paddingHorizontal: 14,
    paddingVertical: 9,
    borderRadius: 10,
    backgroundColor: Colors.bubbleColor,
  },
  buttonHovered: {
    opacity: 0.7,
  },
  buttonText: {
    fontSize: 13,
    fontWeight: "600",
    color: Colors.whiteColor,
  },
});
